import styled from '@emotion/styled';
import {
  spacing,
  fontWeight,
  fontSize,
  borderRadius,
  mediaMax,
} from 'presentations/views/styles';
import {
  black,
  gray01,
  gray02,
  gray03,
} from 'presentations/views/styles/color';
import CategoryList from 'presentations/views/components/molecules/ResourceCategoryList';
import TagList from 'presentations/views/components/molecules/ResourceTagList';
import Image from 'presentations/views/components/atoms/Image';
import Link from 'presentations/views/components/atoms/Link';
import { ResourceListItem } from 'presentations/api/schema/resources';
import { resourcePath } from 'presentations/routes/path';
import { formatToDate } from 'infras/datetime';

export interface Props {
  item: ResourceListItem;
  isThumbnailSizeNormal?: boolean;
}

export default function Component(props: Props) {
  const link = resourcePath(props.item.categories[0].slug, props.item.slug);

  return (
    <Container key={props.item.id}>
      <MediaItem href={link}>
        {props.item.thumbnailUrl && (
          <MediaImageContainer>
            <MediaImage
              alt={props.item.title}
              loading="lazy"
              src={props.item.thumbnailUrl}
            />
          </MediaImageContainer>
        )}
      </MediaItem>
      <Content>
        <StyledCategoryList categories={props.item.categories} />
        <ContentTextLink href={link}>{props.item.title}</ContentTextLink>
        <ContentDate>{formatToDate(props.item.updatedAt)}</ContentDate>
        <TagList tags={props.item.tags} />
      </Content>
    </Container>
  );
}

const Container = styled.div``;
const MediaItem = styled(Link)`
  img {
    max-width: 100%;
  }
`;
const Content = styled.div`
  margin-top: ${spacing(16)} 0;
`;
const ContentTextLink = styled(Link)`
  display: block;
  font-weight: ${fontWeight('bold')};
  color: ${black};
  font-size: ${fontSize(18)};
  ${mediaMax.tablet} {
    font-size: ${fontSize(16)};
  }
`;
const ContentDate = styled.div`
  color: ${gray01};
  font-size: ${fontSize(12)};
  margin-top: ${spacing(4)};
  margin-bottom: ${spacing(8)};
`;
const MediaImageContainer = styled.div`
  margin-bottom: ${spacing(16)};
  width: 100%;
  overflow: hidden;
  position: relative;
  height: 197px;
`;
const MediaImage = styled(Image)`
  width: 100%;
  height: 197px;
  object-fit: cover;
  border-radius: ${borderRadius(6)};
  z-index: 0;
`;

const StyledCategoryList = styled(CategoryList)`
  margin-bottom: ${spacing(8)};
`;
